import React from "react";
import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
      html {
        scroll-behavior: smooth;
      }
      body {
        margin: 0;
        font-family: Inter, sans-serif;
      }

      button {
        cursor: pointer;
        outline: none;
        background-color: transparent;
        border: none;
        padding: 0;
        font-family: inherit;

        &:disabled {
          cursor: default;
        }
      }

      div {
        box-sizing: border-box;
      }

      a {
        cursor: pointer;
        text-decoration: none;
      }

      b {
        font-weight: bold;
        font-family: inherit;
      }

      input {
        font-family: inherit;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p {
        padding: 0;
        margin: 0;
      }

      .bootstrap-styles-form{

        button, input {
          font-family: "Inter";
        }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
          /* display: none; <- Crashes Chrome on hover */
          -webkit-appearance: none;
          margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
      }

      input[type=number] {
          -moz-appearance:textfield; /* Firefox */
      }

      .field-boolean {
        .control-label {
          display: none;
          color: var(--text);
        }
      }

      .control-label {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 1.5em;
        color: var(--text);
        margin-bottom: 10px;
          .required {
              color: red
          }
      }

      .field-description {
        font-family: Inter, sans-serif;
        font-size: 14px;
        color: var(--hero-text);
      }
      .form-control{
        border: none;
        background: var(--hero-background);
        border-radius: 4px;
        height: 50px;
        color: var(--hero-text);

        &:focus{
          box-shadow: none !important;
          background: var(--hero-background);
          padding-bottom: 4px;
          color: var(--hero-text);

        }


        &:active{
          background: var(--hero-background);
          padding-bottom: 4px;
          color: var(--hero-text);

        }
      }

      .error-detail {
        background: #f80d0d;
        padding: 6px 12px 6px 10px;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        font-family: Inter, sans-serif;
        display: flex;
        flex-direction: column;
        justify-content: center;

        li {
          display: block;
          margin-bottom: 0px;
          font-family: Inter, sans-serif;
        }

      }

      .text-danger{
        font-size: 12px;
        font-weight: 700;
        color: white !important
      }

      .rjsf {
        position: relative;
        width: 100%;

        .help-block {
            color: #888;
            font-size: .8em;
            padding-top: .8em;
        }

        fieldset {
            .field{
              width: 100%;
              margin-bottom: 40px;
            }
        }

        select {
          display: block;
          box-sizing: border-box;
          margin: 0;
          -webkit-appearance: none;
          -moz-appearance: none;
          -ms-appearance: none;
          -o-appearance: none;
          appearance: none;
           background-color: #fff;
          background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAALAgMAAADtpS7uAAAAAXNSR0IB2cksfwAAAAlQTFRFAAAAAAAAAAAAg2PpwAAAAAN0Uk5TAP9/qehVAQAAADlJREFUeJxjmBoaGhrGwKAKpCIYGDiBVAIDAxOQamBgYJgKkgJJRoAoTpAUSBIkxcAwDUwyaDDAAQAlvgq1BCuYFgAAAABJRU5ErkJggg==');
          background-repeat: no-repeat, repeat;
          background-position: right .7em top 40%, 0 0;
          // background-size: .65em auto, 100%;
          }
           .select-css::-ms-expand { display: none; }
           .select-css:hover { border-color: #888; }
           .select-css:focus { border-color: #aaa;
           box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);
           box-shadow: 0 0 0 3px -moz-mac-focusring;
          color: #222;
           outline: none;
          }
           .select-css option { font-weight:normal; }
           *[dir="rtl"] .select-css, :root:lang(ar) .select-css, :root:lang(iw) .select-css {
          background-position: left .7em top 50%, 0 0;
          padding: .6em .8em .5em 1.4em;
          }
          option {
            padding: 5px;
          }
         .btn-info {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 13px 37px;
            height: 51px;
            background: var(--button);
            border-radius: 4px;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 1.5em;
            width: 100%;
            margin-top: 20px;
            border: 2px solid;
            border-color: var(--button-border);

            display: flex;
            align-items: center;

            box-shadow: 0px 20px 30px 0px rgb(0 0 0 / 20%);

            :focus {
              box-shadow: 0px 4px 30px 5px rgba(0, 0, 0, 0.2);
              border-color: var(--button-border);
              background: var(--button);
            }
        }
      }}
    `;
